export default {"src":"/_next/static/media/GRAB.afd18f07.svg","height":18,"width":18};